import http from '@core/fetch'

export default {
  getInfo: () => http('/p/wedding/Admin/APIMicroShop'),
  postInfo: body => http.post('/p/wedding/Admin/APIMicroShop', { body })
}
